import { useIntl } from "react-intl";

const ReportingAndAnalytics = () => {
    const intl = useIntl();
    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ReportingAndAnalytics.header",
            defaultMessage: "Reporting and analytics"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ReportingAndAnalytics.body",
            defaultMessage:
                "Choose from a set of default reports, or customize your own to help you track specific team goals, like Time to Resolution or SLA success rates."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.ReportingAndAnalytics.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about reports."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href="https://support.atlassian.com/jira-service-management-cloud/docs/discover-new-trends-with-service-project-reports/"
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default ReportingAndAnalytics;
